import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.svg'
import { getImgURL } from '@shared-submodule/utils'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const SquadsTeamCard = ({ data, title, activeTeam = '', width = 767 }) => {
  return (
    <div
      className={`${styles.squadsTeamCard} ${title && styles.title} ${!title && 'cursor-pointer'} ${
        activeTeam === data?._id && styles.activeTeam
      } ${width > 767 && 'd-flex'} common-box align-items-center`}>
      {!title && (
        <>
          <div className={`${styles.icon} overflow-hidden me-2`}>
            <MyImage
              src={getImgURL(data?.oImg?.sUrl) || teamPlaceholder}
              blurDataURL={teamPlaceholder}
              alt={data?.sFullName || 'Team Image'}
              placeholder="blur"
              layout="responsive"
              width="40"
              height="40"
              errorImage={teamPlaceholder}
              autoRadiusImage
            />
          </div>
        </>
      )}
      <h3 className={`small-head small-head font-semi mb-0 w-100 ${styles.teamHead}`}>
        {title || data?.sFullName || data?.sTitle || data?.sFirstName}
      </h3>
    </div>
  )
}
SquadsTeamCard.propTypes = {
  data: PropTypes.object,
  title: PropTypes.string,
  activeTeam: PropTypes.string,
  width: PropTypes.number
}

export default SquadsTeamCard
